import React, { Component } from 'react';

class Fourth extends Component {
  render() {
    return (
      <p className="Fourth-intro">
        Hello from <code>Fourth</code>.
      </p>
    );
  }
}

export default Fourth;



// WEBPACK FOOTER //
// ./src/components/Page/Fourth/Fourth.js